<template>
  <v-combobox
    v-model="duration"
    :items="['00:30', '01:00', '02:00', '03:00']"
    outlined
    :dense="dense"
    class="right-align-number-input"
    :placeholder="$t('plannedService.durationInputPlaceholder')"
    :rules="[
      ...rules,
      (v) =>
        isValid(v) || $t('plannedService.invalidDurationInput'),
    ]"
    hide-details="auto"
  />
</template>

<script>
export default {
  name: 'DurationSelect',
  props: {
    value: {
      required: true,
    },
    rules: {
      type: Array,
      default: () => [],
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    duration: {
      get() {
        return this.convertToDurationString(this.value);
      },
      set(val) {
        if (!this.isValid(val)){
          return;
        }
        this.$emit('input', this.convertToMinutes(val));
      },
    },
  },
   methods:{

    isValid(value){
      return !value || /^\d+$/.test(value) || /^\d+:\d+$/.test(value);
    },

    convertToDurationString(mins) {
      if (typeof mins !== 'number'){
        return null;
      }

      const hours = Math.floor(mins / 60).toString(10);
      let minutes = (mins % 60).toString(10);
      if (minutes.length < 2){
        minutes = '0' + minutes;
      }
      return `${hours}:${minutes}`;
    },
    convertToMinutes(durationString) {
      if (durationString && typeof durationString === 'string') {
        const values = durationString.split(':').map(val => parseInt(val, 10));

        if (values.some(val => isNaN(val))){
          return null;
        }

        //got one number, assuming it meant minutes
        if (values.length === 1 ){
          return values[0];
        }
        //Got two numbers. assuming that meant hours and minutes
        if(values.length === 2){
          return values[0]*60 + values[1];
        }
      }
      return null;
    },
  },
};
</script>
